// extracted by mini-css-extract-plugin
module.exports = {"multipleUsersContainer":"AddNewUsers_multipleUsersContainer__2oY-2","multipleUsersCountContainer":"AddNewUsers_multipleUsersCountContainer__3Aahm"};